<template>
  <div class="not-page"></div>
</template>

<script>
import { getQueryString, refer, zhugeTrack } from "@/utils/utils";
export default {
  name: 'not-page',
  data() {
    return {
      
    }
  },
  mounted(){
    // 获取登录页跳转的页面
    this.referUrl = getQueryString("refer") ? decodeURIComponent(getQueryString("refer")) : "";
    // 是否是回车课堂登录页
    this.codeLogin = getQueryString("codeLogin");
    this.$router.push({
      name:"login",
      query: {
        refer: this.referUrl ? this.referUrl : undefined,
        codeLogin: this.codeLogin ? this.codeLogin : undefined,
      },
    })
  }
}
</script>

<style lang="scss" scoped>

</style>